
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import App from './App';
import './index.css';
import { GoogleMapsProvider } from './contexts/google_map_context';

// Disable React's development mode double-invocation of effects
const root = ReactDOM.createRoot(document.getElementById('root')!);

// Comment out StrictMode to prevent double-invocation of effects in development
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <GoogleMapsProvider>
        <App />
      </GoogleMapsProvider>
    </Provider>
  // </React.StrictMode>
);
